import { API_WRONG, API_NOT_FOUND, FILE_SIZE_LARGE } from "./messages";
// import { RtmRole } from 'agora-access-token';
import moment from 'moment';

export const extractFileName = (fileObject) => {
  let filename;
  if (typeof fileObject == 'object') {
    filename = fileObject[1];
  } else {
    filename = fileObject.split(',').pop();
  }
  return filename;
}

export const DataURIToBlob = (dataURIObj) => {
  // console.log('type of', typeof dataURIObj);
  // console.log('byteString', dataURIObj);

  let dataURI, extension;

  if (typeof dataURIObj == 'object') {
    dataURI = dataURIObj[0];
    extension = dataURIObj[2];
  } else {
    let datahold = dataURIObj.split(',').pop();
    dataURI = dataURIObj.substring(0, dataURIObj.length - (datahold.length + 1));
    let tempRemoval = dataURI.split(',').pop();
    dataURI = dataURIObj.substring(0, dataURI.length - (tempRemoval.length + 1));
    extension = datahold.split('.').pop();
  }

  // console.log('data ', dataURI);
  // console.log('extension ', extension, extension.length);
  const splitDataURI = dataURI.split(',');
  // console.log('splitDataURI', splitDataURI);

  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
  // console.log('byteString', byteString);
  // const mimeString = splitDataURI[0].split(':')[1].split(';')[0]
  // console.log('byteString', byteString);
  // console.log('mimeString', mimeString);
  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++)
    ia[i] = byteString.charCodeAt(i)

  return new Blob([ia], { type: extension })
}

export const imageToBlob = (dataURI) => {
  // console.log('will see, ', dataURI);
  var byteString, mimestring;


  if (dataURI.split(',')[0].indexOf('base64') !== -1) {
    byteString = atob(dataURI.split(',')[1])
  } else {
    byteString = decodeURI(dataURI.split(',')[1])
  }

  mimestring = dataURI.split(',')[0].split(':')[1].split(';')[0]
  // console.log('byteString, ', byteString);
  // console.log('mimestring, ', mimestring);
  var content = new Array();
  for (var i = 0; i < byteString.length; i++) {
    content[i] = byteString.charCodeAt(i)
  }

  return new Blob([new Uint8Array(content)], { type: mimestring });
}

export const apiErrorHandler = (errorData, enqueueSnackbar) => {
  // console.log('err ro d', errorData);
  // console.log('errorData', errorData.data, typeof (errorData.data));

  try {


    if (errorData.status === 404) {
      enqueueSnackbar(API_NOT_FOUND, { variant: "error" });
      return true;
    }

    if (errorData.status === 413) {
      enqueueSnackbar(FILE_SIZE_LARGE, { variant: "error" });
      return true;
    }

    if (errorData === undefined) {
      enqueueSnackbar(API_WRONG, { variant: "error" });
      return true;
    }

    if (errorData.data === undefined &&
      errorData.data === null &&
      errorData.data === 'null' &&
      errorData.data === 'undefined'
    ) {
      enqueueSnackbar(API_WRONG, { variant: "error" });
      return true;
    }

    if (errorData.data.errors && errorData.data.errors === undefined && errorData.data.errors === null) {
      enqueueSnackbar(API_WRONG, { variant: "error" });
      return true;
    }

    if (errorData.data.errors.length !== undefined && errorData.data.errors.length > 0) {

      const errors = errorData.data.errors;
      for (let i = 0; i < Object.keys(errorData.data.errors).length; i++) {
        enqueueSnackbar(errors[i], { variant: "error" });
      }
      return true;
    }

    if (typeof (errorData.data.errors) === 'object', Object.keys(errorData.data.errors).length > 0) {

      Object.keys(errorData.data.errors).map(function (key) {

        // console.log('type of error value', errorData.data.errors[key], typeof (errorData.data.errors[key]));

        if (typeof (errorData.data.errors[key]) === 'string') {
          enqueueSnackbar(errorData.data.errors[key], { variant: "error" });
        } else {

          errorData.data.errors[key].map((item, index) => {
            enqueueSnackbar(`${key} : ${item}`, { variant: "error" });
          });

        }

      });

      return true;
    }

    enqueueSnackbar(API_WRONG, { variant: "error" });
    return true;

  } catch (error) {
    enqueueSnackbar(API_WRONG, { variant: "error" });
    return true;
  }


}

export const signupApiResponseError = (errorData, enqueueSnackbar) => {
  if (Object.keys(errorData).length) {
    Object.keys(errorData).map(function (item, index) {

      errorData[item].map((errorMessage, arrrayIndex) => {
        enqueueSnackbar(`${item} : ${errorMessage}`, { variant: "error" });
      });

    });
  } else {
    enqueueSnackbar(API_WRONG, { variant: "error" });
  }
}

export const arrayOfUploadFields = ["Upload list of IP's", "Upload Audit Report", "Picture"];


export const DataURIToBlobAlt = (dataURI) => {
  const splitDataURI = dataURI.split(',')
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++)
    ia[i] = byteString.charCodeAt(i)

  return new Blob([ia], { type: mimeString })
}

export const sliceName = (name) => {
  if (name) {
    const firstChar = name.slice(0, 1);
    return <h1>{firstChar}</h1>;
  } else {
    return <h1>N/A</h1>;
  }
}

export const sizeCalculator = (sizeToProcess) => {

  // console.log('sizeToProcess ', sizeToProcess);

  if (sizeToProcess <= 1024) {
    sizeToProcess = sizeToProcess + 'bytes';
  } else if (sizeToProcess / 1024 < 1024) {
    sizeToProcess = parseInt('' + sizeToProcess / 1024 + '') + 'kb';
  } else if (sizeToProcess / 1024 > 1024) {
    sizeToProcess = parseFloat('' + sizeToProcess / (1024 * 1024) + '').toFixed(2) + 'mb';
  }

  return sizeToProcess;
}

export const extractExtension = (fileName) => {
  const ifDotExist = fileName.indexOf(".");
  // console.log('ifDotExist ', ifDotExist);
  if (ifDotExist === -1) {
    return null;
  } else {
    return fileName.split('.').pop();
  }
}

export const arrayOfDefData = [
  // ["End Date", moment(Date.now()).format("YYYY-MM-DD")],
  // ["Start Date", moment(Date.now()).format("YYYY-MM-DD")],
  ["Mobile Application", "I don't have mobile application"],
  ["Breach History", false]
];

export function waitTillMilliSeconds(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}

export function makeId(length) {
  let result = "";
  let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function tokenExpireTime(expireTime) {
  expireTime = parseInt(expireTime.toString(), 10);
  const currentTime = Math.floor(Date.now() / 1000);
  let privilegeExpireTime = currentTime + expireTime;
  return privilegeExpireTime;
}

export function filterImageUrl(imageUrl) {
  const baseUrl = imageUrl.split('?')[0];
  return baseUrl;
}


export function convertDate(baseDate) {
  const dateObject = moment(baseDate, 'YYYY-MM-DD');
  return dateObject.format('DD-MM-YYYY');
}

export function isEmpty(value) {
  if (value === null || value === "null") {
    return true;
  } else if (typeof value !== 'number' && value === '') {
    return true;
  } else if (value === 'undefined' || value === undefined) {
    return true;
  } else if (value !== null && typeof value === 'object' && !Object.keys(value).length) {
    return true;
  } else {
    return false;
  }
}


// export const SUBSCRIBER = RtmRole.SUBSCRIBER;
// export const PUBLISHER = RtmRole.PUBLISHER;

export const imageData = 'data:image/webp;base64,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'